import React from 'react'
import {Tabs, Tab} from 'react-bootstrap'
import Icon from 'react-fa'
import _ from 'lodash';
import StripeComponent from './StripeComponent'
import PaypalComponent from './PaypalComponent'
import InvoiceComponent from './InvoiceComponent';
import paymentProvider from './PaymentSelector';
let config = require('config');

class PaymentComponent extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      paymentProvider: 'stripe'
    }
  }

  setPaymentProvider(newProviderName) {
    this.setState({
      paymentProvider: newProviderName
    })
  }

  getPaymentComponent() {
    const Module = paymentProvider[this.props.provider]['payment'];
    return <Module  {...this.props} />
  }

  render() {
    return <div>
      <Tabs onSelect={this.setPaymentProvider.bind(this)} activeKey={this.state.paymentProvider} defaultActiveKey={this.state.paymentProvider}>
      {
        (() => {
          let title = _.capitalize(this.props.provider);
          switch (this.props.provider){
          case 'stripe':
            title = <Icon size="2x" name="cc-stripe" />
          }
          return <Tab eventKey="stripe" title={title} />

        })()
      }
        {/*<Tab eventKey="paypal" disabled title={<Icon size="2x" name="cc-paypal" />}/>*/}
      </Tabs>
      <br />
      <div>
        {this.getPaymentComponent()}
      </div>
    </div>


  }
}

PaymentComponent.displayName = 'PaymentComponent';
export default PaymentComponent;



// WEBPACK FOOTER //
// ./src/components/common/PaymentComponent.js